import styled from '@emotion/styled';
import React from 'react';
import { TextField } from '../../../../../../components/TextField';

const styles = {
  root:{
    background:"#f2f2f2",
    width:"100px",
    maxWidth:"100px",
    fontWeight:"normal"
  }
}

export const DadosPlano = ({ dados, handleDados, }) => {
const tiposPagamentos = [ 
  {label:'Valor mensal', field: 'valorMensal', max:8},
  // {label:'Valor anual', field: 'valorAnual',max:8}
];

  return (
    <Content>
      <TextField
        label="Titulo"
        placeholder="Digite o titulo"
        value={dados.titulo}
        onChange={(e) => handleDados(e.target.value, 'titulo')}
      />
      <Row>
        {tiposPagamentos.map((tipo, index) => {
          const { label, field,max } = tipo || {};

          return (
            <TextField
              key={index}
              label={label}
              mask={'moeda'}
              placeholder="Digite o valor"
              value={String(dados[field])}
              maxLength={max}
              onChange={(e) => handleDados(e.target.value, field)}
            />
          );
        })}
        </Row>
        <TextField
        label={"Quantidade adicional"}
        placeholder="Quantidade adicional"
        value={dados.quantidadeAdicional}
        onChange={(e) => handleDados(e.target.value, 'quantidadeAdicional')}
        maxLength={5}
        />
        <Row>
           <TextField
              label="Valor adicional Beneficiário"
              mask={'moeda'}
              placeholder="Digite o valor"
              value={String(dados.valorAdicionalBeneficiario)}
              onChange={(e) => handleDados(e.target.value, 'valorAdicionalBeneficiario')}
            />
             <TextField
              label="Valor adicional Dependente"
              mask={'moeda'}
              placeholder="Digite o valor"
              value={String(dados.valorAdicionalDependente)}
              onChange={(e) => handleDados(e.target.value, 'valorAdicionalDependente')}
            />
        </Row>
          {/*<ContentField>
            <LabelField>Tipo de pessoa:</LabelField>
            <SelectSearch
            placeholder={"Selecione física ou jurídica"}
            value={dados.tipoPessoa}
            elements={tipoPessoa}
            onChange={(e) => handleDados(e,'tipoPessoa',)}
            />
          </ContentField>*/}
      <RowDescricao>
        <TextField
          label={"Descrição"}
          placeholder="Descrição"
          value={dados.descricao}
          onChange={(e) => handleDados(e.target.value, 'descricao')}
          rows={7}
          multiline
        />
      </RowDescricao>

      <RowDescricao>
        <ContentText>A multa sera aplicada caso o contrato seja cancelado antes de
          <TextField
            placeholder="Meses"
            value={dados.mesesFidelidade}
            onChange={(e) => handleDados(e.target.value, 'mesesFidelidade')}
            type={"number"}
            InputProps={{
              classes: {
                root: styles.root,
              },
              style: styles.root
            }}
          />
        </ContentText>
        <ContentText> meses, e o valor cobrado será
          <TextField
            placeholder="Percentual da multa"
            value={dados.valorMulta}
            mask={'percentil'}
            onChange={(e) => handleDados(e.target.value, 'valorMulta')}
            InputProps={{
              classes: {
                root: styles.root,
              },
              style: styles.root
            }}
          />
        </ContentText>
      </RowDescricao>
    </Content>
  );
};

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  display: grid;
  gap: 16px;
  grid-template-rows: repeat(3, max-content);
`;

const Row = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
`;
const RowDescricao = styled.div`
  width: 100%;
`;
const ContentField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ContentText = styled.div`
  display: flex;
  gap: 5px;
  align-content: center;
  align-items: center;
  text-wrap: nowrap;
  font-size : 14px;
  font-weight: 600;
  color: #505050;
`
const LabelField = styled.label`
  color: #868686;
  font-size: 12px;
  height: 16px;
`;
